import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const bonuses = [{
  num: '01',
  title: 'Hoja de Ruta — Tu Primer Consultorio',
  desc: 'Inversión inteligente, habilitación, equipamiento, espacio físico y plan de primeros 90 días.',
  price: '$12.000'
}, {
  num: '02',
  title: 'El Imán de Pacientes — Redes Sociales',
  desc: 'Instagram, Google Mi Negocio, WhatsApp Business, reseñas, contenido, Reels y métricas.',
  price: '$9.000'
}, {
  num: '03',
  title: 'El Protocolo de la Sesión Premium',
  desc: 'Experiencia del paciente, alianza terapéutica, primera sesión, fidelización y alta premium.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Scripts de Venta y Cierre por WhatsApp',
  desc: 'Conversión de consultas en turnos, manejo de precio, objeciones, cancelaciones y seguimiento.',
  price: '$9.000'
}, {
  num: '05',
  title: 'El Mapa de Escalabilidad Kinésica',
  desc: 'Estadios de consultorio, especialización, aumento de honorarios y planificación a 5 años.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Blindaje Profesional Completo',
  desc: 'Matrícula, seguro de mala praxis, ética, datos personales, intrusismo y proceso disciplinario.',
  price: '$10.000'
}];
export function Bonuses() {
  useTrackSection('bonuses', 'Bonuses Section');
  return <section id="bonuses" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(235,248,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-41">
      <div className="mx-auto max-w-4xl" data-id="element-42">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-43">
          Más los{' '}
          <span style={{
          color: '#0077B6'
        }} data-id="element-44">
            6 Bonos Estratégicos
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-45">
          Incluidos en todas las ofertas — sin costo extra
        </p>

        {/* Bonus List */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-6" style={{
        border: '1px solid rgba(0,119,182,0.20)'
      }} data-id="element-46">
          {/* Header */}
          <div className="px-5 py-3" style={{
          backgroundColor: '#0077B6'
        }} data-id="element-47">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-48">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          {/* List */}
          <div className="divide-y divide-gray-100" data-id="element-49">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-3" data-id="element-50">
                {/* Número */}
                <span className="shrink-0 text-lg font-black w-8 text-center" style={{
              color: 'rgba(0,119,182,0.30)'
            }} data-id="element-51">
                  {bonus.num}
                </span>

                {/* Contenido */}
                <div className="flex-1 min-w-0" data-id="element-52">
                  <span className="block text-sm font-black text-gray-900" data-id="element-53">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-54">
                    {bonus.desc}
                  </span>
                </div>

                {/* Precio tachado + GRATIS */}
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-55">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-56">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white rounded-full px-2 py-0.5" style={{
                backgroundColor: '#0077B6'
              }} data-id="element-57">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-4 shadow-sm" style={{
        backgroundColor: 'rgba(0,119,182,0.05)',
        border: '1px solid rgba(0,119,182,0.20)'
      }} data-id="element-58">
          <p className="text-xs font-bold uppercase tracking-widest m-0 mb-1" style={{
          color: '#0077B6'
        }} data-id="element-59">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-60">
            <span className="text-base text-gray-400 line-through" data-id="element-61">
              $58.000
            </span>
            <span className="text-lg font-black" style={{
            color: '#0077B6'
          }} data-id="element-62">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>
    </section>;
}